import { render, staticRenderFns } from "./ActivityStage.vue?vue&type=template&id=4f9ab604&"
import script from "./ActivityStage.vue?vue&type=script&lang=ts&"
export * from "./ActivityStage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports